import React, { useRef, createRef } from "react";
import FacingText from "../components/FacingText";
import SlidingPanel from "../panels/SlidingPanel";
import SlideBottomCase from "../components/SlideBottomCase";
import SlideSideStrut from "../components/SlideSideStrut";

const TopCase = ({ width, height, color, section }) => {
  let posX = 0;
  let caseWidth = width;

  if (section?.left_angle == 90) {
    if (section.sliding_direction == 2 || section.sliding_direction == 3) {//dış birleşim
      posX -= 0.03;
      caseWidth += 0.06;
    } else {
      posX -= 0.07;
      caseWidth += 0.14;
    }
  }
  return (
    <mesh position={[posX, height + 0.04, 0]}><boxGeometry args={[caseWidth, 0.05, 0.2]} /><meshStandardMaterial color={color} /></mesh>
  );
}
const Sliding3D = ({ isExporting, config, isOpenTrigger, aluminumColor, glassColor, glassColor2 }) => {
  const { sections } = config;
  const group = [];
  const leftRefsPerSection = useRef(sections.map(sec =>
    Array(sec.panels.length).fill().map(() => createRef())
  ));
  const rightRefsPerSection = useRef(sections.map(sec =>
    Array(sec.panels.length).fill().map(() => createRef())
  ));

  let posX = 0;
  let posZ = 0;
  let angleSum = 0;
  const spacing = -0.02;

  sections.forEach((section, sectionIndex) => {
    const panels = section.panels;
    const isOrtadanBol = section.sliding_direction == 2 || section.sliding_direction == 10;
    const leftPanelRefs = leftRefsPerSection.current[sectionIndex];
    const rightPanelRefs = rightRefsPerSection.current[sectionIndex];

    const angle = parseFloat(section.angle);
    const leftAngle = section?.left_angle || 0;

    const skipRight = parseFloat(angle) == 90;
    const skipLeft = parseFloat(leftAngle) == 90;
    const width = parseFloat(section.size.width) / 1000;
    const sectionWidth = width + (panels.length - 1) * spacing + (isOrtadanBol ? 0.03 : 0);
    const height = parseFloat(section.size.height) / 1000;
    const angleRad = (angleSum * Math.PI) / 180;
    const dirX = Math.cos(angleRad);
    const dirZ = Math.sin(angleRad);

    if (skipLeft) {
      if (angleSum % 180 == 0) {
        if (section.sliding_direction == 2 || section.sliding_direction == 3) {//dış birleşim
          posZ -= 0.06;
          posX += 0.07;
        } else {//iç birleşim
          posZ += 0.045;
          posX -= 0.02;
        }
      } else if (angleSum % 90 == 0) {
        if (section.sliding_direction == 2 || section.sliding_direction == 3) {//dış birleşim
          posZ -= 0.03;
          posX -= 0.12;
        } else {//iç birleşim
          posZ += 0.03;
          posX += 0.05;
        }
      }
    }

    const sectionStartX = posX + (width / 2) * dirX;
    const sectionStartZ = posZ + (width / 2) * dirZ;
    const sectionBaseX = posX; // başlangıç X
    const sectionBaseZ = posZ; // başlangıç Z
    const sectionPosition = [sectionStartX, 0, sectionStartZ];
    const rotationY = -angleSum * (Math.PI / 180);

    posX += dirX * width;
    posZ += dirZ * width;
    angleSum += angle;

    const totalPanels = panels.length;
    let rayCount = totalPanels;
    let leftCount = totalPanels;
    let rightCount = 0;
    let divider = 1;

    //sağa sola ortadan böl demek
    if (isOrtadanBol) {
      rayCount = Math.floor(totalPanels / 2);
      leftCount = Math.floor(totalPanels / 2);
      rightCount = totalPanels - leftCount;
      divider = 2;
    }

    const leftPanels = panels.slice(0, leftCount);
    const rightPanels = panels.slice(leftCount);


    group.push(
      <group key={sectionIndex} position={sectionPosition} rotation={[0, rotationY, 0]}>
        <SlideBottomCase width={sectionWidth} rayCount={rayCount} color={aluminumColor} isThreshold={config.isThreshold} section={section} />
        <TopCase width={sectionWidth} height={height} color={aluminumColor} section={section} />
        <SlideSideStrut height={height} isLeft={true} color={aluminumColor} sectionWidth={sectionWidth} skip={skipLeft} isThreshold={config.isThreshold} />
        <SlideSideStrut height={height} isLeft={false} color={aluminumColor} sectionWidth={sectionWidth} skip={skipRight} isThreshold={config.isThreshold} />

        {leftPanels.map((panel, i) => {
          const index = Math.abs(leftPanels.length - i - 1);
          const isLeftSlide = section.sliding_direction == 6 || section.sliding_direction == 2 || section.sliding_direction == 3 || section.sliding_direction == 10;
          return (
            <SlidingPanel
              index={index}
              titleIndex={i}
              panelWidth={(width / leftCount) / divider}
              height={height}
              side={isLeftSlide ? "left" : "right"}
              spacing={spacing}
              totalPanels={totalPanels}
              isOpenTrigger={isOpenTrigger}
              panelRefs={leftPanelRefs}
              direction={panel.direction}
              isDouble={config.isDouble}
              leftAngle={leftAngle}
              rightAngle={angle}
              almColor={aluminumColor}
              glassColor={glassColor}
              glassColor2={glassColor2}
              section={section}
              isExporting={isExporting}
            />
          );
        })}

        {rightPanels.map((panel, i) => {
          const index = Math.abs(rightPanels.length - i - 1);
          const titleIndex = Math.abs(leftPanels.length + (rightPanels.length - i - 1));
          let isLeftSlide = section.sliding_direction == 3;//sağa kaydır.
          return (
            <SlidingPanel
              index={index}
              titleIndex={titleIndex}
              panelWidth={(width / rightCount) / divider}
              height={height}
              side={isLeftSlide ? "left" : "right"}
              spacing={spacing}
              totalPanels={totalPanels}
              isOpenTrigger={isOpenTrigger}
              panelRefs={rightPanelRefs}
              direction={panel.direction}
              isDouble={config.isDouble}
              leftAngle={0}
              rightAngle={angle}
              almColor={aluminumColor}
              glassColor={glassColor}
              glassColor2={glassColor2}
              section={section}
              isExporting={isExporting}
            />
          );
        })}
      </group>
    );
    {
      !isExporting && (group.push(
        <>
          <FacingText
            position={[sectionBaseX, -0.15, sectionBaseZ]}
            fontSize={0.1}
            color="black"
          >
            P{sectionIndex + 1}
          </FacingText>
          <FacingText
            position={[sectionBaseX, -0.25, sectionBaseZ]}
            fontSize={0.08}
            color="black"
          >
            {section.size.width}x{section.size.height}
          </FacingText>
        </>
      ))
    };

    {
      !isExporting && (group.push(
        <FacingText
          position={[posX, section.size.height / 1000 + 0.2, posZ]}
          fontSize={0.1}
          color="black"
        >
          {section.angle}°
        </FacingText>
      ))
    };

  });

  return (
    <>
      {group}
    </>
  );
};

export default Sliding3D;